import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";
import Breakpoints from "common/breakpoints";

export default makeStyles((theme: MuiTheme) => {
  const { primary } = theme.palette;

  return {
    button: {
      textTransform: "capitalize",
      color: primary.dark,
      "& .MuiButton-startIcon": {
        marginRight: 10
      },
      [theme.breakpoints.down(Breakpoints.SM_600)]: {
        marginLeft: -6
      }
    },
    optional: {
      textTransform: "lowercase",
      color: primary.light,
      fontSize: 12,
      marginLeft: 3
    }
  };
});
